<template>
  <component :is="getContainerType" :class="getClassName">
    <table>
      <tr>
        <th v-for="(colHeader, key) in getColHeaders" :key="key">
          {{ $t(colHeader) }}:
        </th>
      </tr>
      <tr
        v-for="(qtyRow, key) in getQuantities"
        :key="key"
        :class="{
          active: activeClass(qtyRow.quantity),
          on_demand: qtyRow.on_demand
        }"
      >
        <td>{{ $t("from") }} {{ formatQty(qtyRow.quantity) }}</td>
        <td v-if="qtyRow.on_demand"></td>
        <td v-if="qtyRow.on_demand" :colspan="getColHeaders.length - 1">
          <div v-html="qtyRow.on_demand"></div>
        </td>
        <td v-if="!qtyRow.on_demand && canDisplayNetPrice()">
          {{ qtyRow.formatted_price_per_unit }}
        </td>
        <td v-if="!qtyRow.on_demand && canDisplayGrossPrice()">
          {{ qtyRow.formatted_gross_price_per_unit }}
        </td>
      </tr>
    </table>
  </component>
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

import constants from "../../helpers/constants";

function quantity_debounce(fn, delay) {
  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

export default {
  computed: {
    ...mapState(useChangeOptionsStore, [
      "getQuantities",
      "getHasGrossPrice",
      "getSelectedQuantity"
    ]),
    ...mapState(useWebproductStore, ["getPriceDisplayType", "getEnableLoader"]),
    getColHeaders: function () {
      let headers = ["Quantity"];
      const priceDisplayType = this.getPriceDisplayType;
      if (
        constants.TAX_DISPLAY_TYPE_EXCL_TAX == priceDisplayType ||
        constants.TAX_DISPLAY_TYPE_BOTH == priceDisplayType
      ) {
        headers.push("Net");
      }
      if (
        constants.TAX_DISPLAY_TYPE_INCL_TAX == priceDisplayType ||
        constants.TAX_DISPLAY_TYPE_BOTH == priceDisplayType
      ) {
        headers.push("Gross");
      }
      return headers;
    }
  },

  methods: {
    ...mapActions(useChangeOptionsStore, ["setQuantity", "setPageOption"]),
    setQuantityDebounce: quantity_debounce(function (qty, qtyCode) {
      this.setQuantity({ qty, qtyCode });
    }, 500),
    setQuantityNoDebounce: function (qty, qtyCode) {
      this.setQuantity({ qty, qtyCode });
    },
    activeClass: function (qty) {
      return this.getSelectedQuantity == qty;
    },
    canDisplayNetPrice: function () {
      return (
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_EXCL_TAX ||
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_BOTH
      );
    },
    canDisplayGrossPrice: function () {
      return (
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_INCL_TAX ||
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_BOTH
      );
    },
    formatQty: function (qty) {
      return qty >= 1000 ? qty.toLocaleString("de-DE") : qty.toString();
    }
  },
  props: ["hideContainer"]
};
</script>
